import React from 'react';
import { Badge, Button, Glyphicon, Col, Row, Image } from 'react-bootstrap';
import moment from 'moment';
import '../../../css/flow-library.less';
import translations from '../../translations';
import Modal from '../generic/Modal';

/**
 * @description Display a modal to give the user more information about the selected flow package
 */
const FlowLibraryViewModal = ({ item, hideModal, dateFormat, onInstall }) => (
    <Modal
        onHide={hideModal}
        className="flow-library"
        dialogClassName="view-modal"
        renderHeader={() => (
            <Row>
                <Col className="name" md={9}>
                    <h5>
                        {item.name}
                    </h5>
                </Col>
            </Row>
        )}
        renderBody={() => (
            <Row>
                <hr />
                <Col md={3}>
                    <Row>
                        <Col className="type-header">
                            {translations.FL_heading_type}
                        </Col>
                    </Row>
                    <Row>
                        <Col className="type">
                            {item.type}
                        </Col>
                    </Row>
                    <Row>
                        <Col className="published-header">
                            {translations.FL_heading_published}
                        </Col>
                    </Row>
                    <Row>
                        <Col className="published">
                            {moment(item.publishedDate).format(dateFormat)}
                            {moment(item.publishedDate).isAfter(moment().subtract(1, 'month')) ? <Badge>{translations.FL_badge_new}</Badge> : null}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button onClick={onInstall} className="install" bsStyle="primary">
                                <Glyphicon glyph="save" />
                                <span>{translations.FL_button_install}</span>
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col md={9}>
                    <Row>
                        <Col className="description">
                            {item.description}
                        </Col>
                    </Row>
                    <Row className="flow-graph margin-top">
                        <Image
                            className="preview-image"
                            src={`${manywho.cdnUrl}/flow-library-assets/images/graphs/${encodeURIComponent(item.name)}.png`}
                        />
                        <div className="white-shading-outer">
                            <div className="white-shading" />
                        </div>
                    </Row>
                </Col>
            </Row>
        )}
    />
);

export default FlowLibraryViewModal;
